import {
  TextInput,
  PasswordInput,
  Title,
  Text,
  Container,
  Button,
  Space,
  Stack,
  Center,
  Box,
  Image,
  Flex,
  Divider,
  MultiSelect,
  LoadingOverlay,
} from "@mantine/core";
import { IconBrandTwitter } from "@tabler/icons";
import { useEffect, useState } from "react";
import { Mixpanel } from "../../../utilities/Mixpanel/MixpanelHelper";
import { WebAppEvents } from "../../../utilities/Mixpanel/AnalyticeEventWebApp";
import {
  convertToHyphenSeparated,
  isValidEmail,
} from "../../../utilities/HelperFunctions";
import { PrivacypolicyChecked } from "../../../_parentsApp/InstituteMobileApp/utils/PrivacyPolicyCheckbox";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/ReduxStore";
import GoogleSignin from "../GoogleAuth/GoogleSignin";
import {
  AddNewbatch,
  GetAllSubjectsForInstitute,
} from "../../../_parentsApp/features/instituteSlice";
import {
  teacherOnboarding,
  updateSubjectsInInstitute,
} from "../../../features/UserSubject/TeacherSubjectSlice";
import { useNavigate } from "react-router-dom";
import { GetUser } from "../../../utilities/LocalstorageUtility";
import { GetAllSubjects } from "../../../_parentsApp/features/InstituteSubjectSlice";
import { TeacherPageEvents } from "../../../utilities/Mixpanel/AnalyticeEventTeacherApp";
import { useMediaQuery } from "@mantine/hooks";

interface LoginProps {
  OnLoginClick: (details: LoginFormDetails) => void;
  OnForgotPasswordClick: () => void;
  OnSignupClick: () => void;
  iserror: boolean;
  setisError: (val: boolean) => void;
  showOnboarding: boolean;
  instituteId: string;
  userId: string;
}

interface SubjectData {
  subjectId: string;
  subjectName: string;
}

export enum LoginUsers {
  ADMIN = "ADMIN",
  TEACHER = "TEACHER",
  TEACHERADMIN = "TEACHERADMIN",
  ADMINISTRATOR = "ADMINISTRATOR",
  OWNER = "OWNER",
}

export function Login(props: LoginProps) {
  const [emailError, setEmailError] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedSubjects, setSelectedSubjects] = useState<string[]>([]);
  const [subjects, setSubjects] = useState<SubjectData[]>([]);
  const navigate = useNavigate();

  enum ValueChangeFieldType {
    email,
    password,
  }

  const [loginDetails, setLoginDetails] = useState<LoginFormDetails>({
    email: "",
    password: "",
    name: "",
  });
  const [isConditionsAccepted, setIsConditionsAccepted] =
    useState<boolean>(true);

  const instituteDetails = useSelector<RootState, InstituteDetails | null>(
    (state: any) => state.instituteDetailsSlice.instituteDetails
  );
  useEffect(() => {
    GetAllSubjects(["BOD-9dabe90f-5c8f-43eb-8c48-c527b1555793"])
      .then((response: any) => {
        const extractedSubjects: SubjectData[] = response.reduce(
          (acc: SubjectData[], data: any) => {
            const classSubjects = data?.classes?.reduce(
              (classAcc: SubjectData[], cls: any) => {
                const subjects = cls.subjects.map((subject: any) => ({
                  subjectId: subject._id,
                  subjectName: `${cls.name} ${subject.name}`,
                }));
                return classAcc.concat(subjects);
              },
              []
            );
            return acc.concat(classSubjects || []);
          },
          []
        );
        setSubjects(extractedSubjects);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [props.instituteId]);

  const onProceedClick = () => {
    // teacherOnboarding
    setIsLoading(true);
    teacherOnboarding({
      subjectIds: selectedSubjects,
      userId: props.userId,
      instituteId: props.instituteId,
    })
      .then((x: any) => {
        setIsLoading(false);
        Mixpanel.track(TeacherPageEvents.USER_SIGN_IN_SUCCESS, {
          email: loginDetails.email,
        });
        const user = GetUser();
        navigate(
          `/${convertToHyphenSeparated(user.instituteName)}/${
            user.instituteId
          }/teach1/all%20simulations`
        );
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    GetAllSubjects(["BOD-9dabe90f-5c8f-43eb-8c48-c527b1555793"])
      .then((response: any) => {
        const data = response[0];
        const extractedSubjects: SubjectData[] = data?.classes?.reduce(
          (acc: SubjectData[], cls: any) => {
            const subjects = cls.subjects.map((subject: any) => ({
              subjectId: subject._id,
              subjectName: `${cls.name} ${subject.name}`,
            }));
            return acc.concat(subjects);
          },
          []
        );
        setSubjects(extractedSubjects);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [props.instituteId]);

  const onUpdateField = (
    fieldType: ValueChangeFieldType,
    updatedValue: string
  ) => {
    var nextFormState: LoginFormDetails | null = null;
    props.setisError(false);
    if (fieldType === ValueChangeFieldType.email) {
      setEmailError(!isValidEmail(updatedValue));
      nextFormState = {
        ...loginDetails,
        email: updatedValue,
      };
    } else if (fieldType === ValueChangeFieldType.password) {
      nextFormState = {
        ...loginDetails,
        password: updatedValue,
      };
    }
    if (nextFormState != null) setLoginDetails(nextFormState);
  };

  function IsInputValid() {
    let isEmailValid = loginDetails.email.length > 0;
    let isPasswordValid = loginDetails.password.length > 0;
    return isEmailValid && isPasswordValid && isConditionsAccepted;
  }

  const onSubmitForm = (e: any) => {
    Mixpanel.track(WebAppEvents.VIGNAM_APP_LOGIN_BUTTON_CLICKED, {
      email: loginDetails.email,
    });
    e.preventDefault();
    setIsSubmitted(true);
    if (isValidEmail(loginDetails.email)) {
      props.OnLoginClick(loginDetails);
    } else {
      Mixpanel.track(WebAppEvents.USER_SIGN_IN_FAILED, {
        error: "Email Validation Failed",
      });
      setEmailError(true);
    }
  };

  const isMd = useMediaQuery(`(max-width:770px)`);

  return (
    <Stack
      w={"100%"}
      p={0}
      align="center"
      justify="center"
      mt={isMd ? "-2rem" : "0"}
    >
      <LoadingOverlay visible={isLoading} />
      <Box w={"70%"}>
        <Text align="center" fz={isMd ? 24 : 36} fw={800}>
          Harness the Power of Interactive Learning.
        </Text>
      </Box>
      {props.showOnboarding ? (
        <>
          <Container w={"70%"} mt={30}>
            <Stack w={"100%"}>
              <MultiSelect
                label="What do you teach?"
                placeholder="Pick Subjects"
                data={
                  subjects.map((subject) => ({
                    value: subject.subjectId,
                    label: `${subject.subjectName}`,
                  })) || []
                }
                value={selectedSubjects}
                onChange={setSelectedSubjects}
              />
              <Button
                fullWidth
                mt="xl"
                onClick={onProceedClick}
                disabled={false}
                style={{ boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.25)" }}
                styles={{
                  root: {
                    "&:disabled": {
                      color: "white",
                      backgroundColor: "#4B65F6",
                    },
                  },
                }}
              >
                Proceed
              </Button>
            </Stack>
          </Container>
        </>
      ) : (
        <Container w={"70%"} mt={30}>
          <Stack w={"100%"}>
            {props.iserror && (
              <Text
                sx={{
                  color: "red",
                }}
                fz={15}
                fs="italic"
              >
                *Email or Password is Incorrect
              </Text>
            )}
            <TextInput
              label="Email"
              placeholder="you@vignam.com"
              required
              value={loginDetails.email}
              error={
                isSubmitted && emailError ? "Invalid email format" : undefined
              }
              onChange={(e) =>
                onUpdateField(ValueChangeFieldType.email, e.target.value)
              }
              styles={{
                label: { fontWeight: 900, color: "black" },
              }}
            />

            <PasswordInput
              label="Password"
              placeholder="Your password"
              required
              value={loginDetails.password}
              onChange={(e) =>
                onUpdateField(ValueChangeFieldType.password, e.target.value)
              }
              styles={{ label: { fontWeight: 900, color: "black" } }}
            />
            <PrivacypolicyChecked
              isConditionsAccepted={isConditionsAccepted}
              setIsConditionsAccepted={setIsConditionsAccepted}
              instituteName={instituteDetails?.name ?? ""}
            />

            <Button
              fullWidth
              mt="xl"
              onClick={onSubmitForm}
              disabled={IsInputValid() == false}
              style={{ boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.25)" }}
              styles={{
                root: {
                  "&:disabled": { color: "white", backgroundColor: "#4B65F6" },
                },
              }}
            >
              Sign in
            </Button>
            <Flex w={"100%"} align={"center"} justify={"center"}>
              or
            </Flex>
            <Flex w={"100%"} justify={"center"} align={"center"} mt={"1rem"}>
              <GoogleSignin
                onGoogleAuthSuccess={(email: string, name: string) => {
                  props.OnLoginClick({
                    email: email,
                    password: "",
                    name: name ?? "User",
                  });
                }}
              />
            </Flex>
          </Stack>
        </Container>
      )}
    </Stack>
  );
}
